import { useDispatch, useSelector } from "react-redux";
import {
  AnalyticsAction,
  AnalyticsConst,
  AuthReduxAction,
  AuthStateModels,
  registerUnauthorizedInterceptor,
  RootState,
  UserReduxAction,
  AnalyticsInstance,
} from "gyg_common";
import React, { useEffect } from "react";
import config from "config";
import jwt_decode from "jwt-decode";
import sign from "jwt-encode";

const WebAuthObsever: React.FC = () => {
  const secret = config.jwtSecret;

  const { isAuthSuccess, currentUser } = useSelector((s: RootState) => s.login);
  const { isAuthTokenExpired } = useSelector((s: RootState) => s.analytics);

  const dispatch = useDispatch();

  /**
   * Gets tokens from async storage and verifies it.
   */
  const getTokenFromLocalStorage = () => {
    const currentUserFromStorage = localStorage.getItem("CurrentUser");

    if (currentUserFromStorage) {
      dispatch(
        AuthReduxAction.setCurrentUserToState(
          jwt_decode(currentUserFromStorage) as AuthStateModels.CurrentUser
        )
      );
      dispatch(AuthReduxAction.setTokenStatus(true));
      return currentUserFromStorage;
    } else {
      dispatch(AuthReduxAction.unsetToken());
    }
  };

  /**
   * Gets current data for token and user's details.
   */
  useEffect(() => {
    registerUnauthorizedInterceptor(dispatch);
    const currentUserFromStorage = getTokenFromLocalStorage();
    if (currentUserFromStorage) {
      dispatch(UserReduxAction.getUserProfile());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // listens to access token changes, may change because refresh token
  useEffect(() => {
    if (currentUser?.accessToken) {
      dispatch(AuthReduxAction.setCurrentUserToState(currentUser));
    }
  }, [currentUser, dispatch]);

  useEffect(() => {
    if (isAuthSuccess) {
      localStorage.removeItem("CurrentUser");
      const jwt = sign(currentUser, secret);
      localStorage.setItem("CurrentUser", jwt);
    } else {
      localStorage.removeItem("CurrentUser");
    }
  }, [isAuthSuccess, currentUser, secret]);

  useEffect(() => {
    if (isAuthTokenExpired) {
      AnalyticsInstance.trackEvent(
        AnalyticsConst.Events.ExpiredRefreshToken,
        {}
      );
      dispatch(AnalyticsAction.setAuthTokenExpired(false));
      localStorage.removeItem("CurrentUser");
      dispatch(UserReduxAction.resetError());
    }
  }, [isAuthTokenExpired, dispatch]);

  return <></>;
};

export default WebAuthObsever;
